import { ROLES } from '@/store/admin'

export default ({ store }) => {
  if (
    store.getters['admin/hasRole']([ROLES.ACCOUNTANT_READ, ROLES.ACCOUNTANT_WRITE, ROLES.ACCOUNTANT_SWIFT]) &&
    !store.getters['swiftMessageOrders/loaded']
  ) {
    return store.dispatch('swiftMessageOrders/loadSwiftOrderMessageTypes')
  }
}
